import React from 'react';
import DropdownItem from "../Dropdown/DropdownItem";

var ComboboxItem = function ComboboxItem(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: onClick,
    className: "overflow-hidden text-truncate",
    title: children
  }, children);
};

ComboboxItem.displayName = "ComboboxItem";
export default ComboboxItem;